import { Component, OnInit } from '@angular/core';
import { NgForm } from "@angular/forms";
import { AuthService } from "../auth.service";
import { Router } from "@angular/router";
import { MaintenanceError } from '../../common/errors/MaintenanceError';
import { GtagService } from '../../gtag/gtag.service';
import { AuthResult, AuthUserModel, CargoFeaturesModel, ClientInfoModel } from '../../model';
import { Logger } from '../../common/logger';
import { MainMenuService } from '../../menu/main-menu.service';
import { ConfirmationService } from 'primeng/api';
import { AppNeedPayError, AppServerError, AppUnauthorizedError } from '../../common/errors';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {
    public showPassword: boolean = false;
    cargoFeatures?: CargoFeaturesModel;
    logger: Logger = Logger.Instance

    constructor(
        private authService: AuthService,
        private router: Router,
        private gtag: GtagService,
        private menuService: MainMenuService,
        private confirmationService: ConfirmationService,
    ) {
        this.gtag.pageview2('Login page');

        this.authService.cargoFeatures().then((cargoFeatures: CargoFeaturesModel) => {
            this.cargoFeatures = cargoFeatures;
        });
    }

    ngOnInit() {
        // this.menuService.buildMenu([]);
    }

    alertMessage(message: string, acceptFn: any = null) {
        this.confirmationService.confirm({
            header: "Внимание!",
            message: message,
            icon: 'pi pi-info-circle',
            acceptButtonStyleClass: 'p-button-danger p-button-sm',
            acceptLabel: "Ok",
            rejectVisible: false,
            accept: () => {
                if (acceptFn && typeof acceptFn === "function") {
                    acceptFn();
                }
            },
        });
    }

    onLogin(form: NgForm) {
        const login = form.value.login.trim();

        const subscr = this.authService.login(login, form.value.passwd.trim()).subscribe({
            next: (user: AuthUserModel) => {
                if (user) {
                    this.gtag.event('login', { enevnt_category: 'login_success', event_label: `User '${login}' with role '${user.userRole}' is logged in` });
                    this.logger.log("login_success", { user: login, role: user.userRole });

                    this.menuService.navigateRouting(user.userRole);
                } else {
                    alert('Критическая ошибка входа в систему.');
                }
            },
            error: (err: any) => {
                subscr.unsubscribe();

                if (err instanceof AppServerError) {
                    const appError = (err as AppServerError).errData
                    switch (appError.message) {
                        case 'no_user_found':
                            this.alertMessage('Пользователь отсутствует или не активен.');
                            break;
                        case 'wrong_credentials':
                            this.alertMessage('Не правильный логин или пароль.');
                            break;
                        default:
                            this.alertMessage(`Неизвестная ошибка входа в систему.\nERROR: ${appError.message}`);
                    }

                } else if (err instanceof AppUnauthorizedError) {
                    const appError = (err as AppUnauthorizedError).errData
                    this.alertMessage('Неправильный логин или пароль.');
                } else if (err instanceof AppNeedPayError) {
                    this.router.navigate(['/needpay']);
                } else if (err instanceof MaintenanceError) {
                    this.logger.info("maintenance_mode", err.message);
                    document.location.href = '/';
                    this.alertMessage(err.message);
                } else {
                    this.alertMessage(`Критическая ошибка входа в систему.\nERROR: ${err.message}`);
                    this.logger.error("login_error", err)
                }
            },
            complete: () => {
                subscr.unsubscribe();
            }
        });
    }

}
